module.exports = __webpack_public_path__ + "static/media/japan12.da46ce72.jpg";